import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      d="M52.6 100.4c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6m0-10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4"
    />
    <path fill="#0597A3" d="M79.1 20.1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="M6.6 48.8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M23.1 92.4l3.9-3.9c.6-.6.6-1.5 0-2.1s-1.5-.6-2.1 0L21 90.3l-3.9-3.9c-.6-.6-1.5-.6-2.1 0s-.6 1.5 0 2.1l3.9 3.9-3.9 3.9c-.6.6-.6 1.5 0 2.1.3.3.7.4 1.1.4s.8-.1 1.1-.4l3.9-3.9 3.9 3.9c.3.3.7.4 1.1.4s.8-.1 1.1-.4c.6-.6.6-1.5 0-2.1zM108.6 27H103v-5.6c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V27h-5.6c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h5.6v5.6c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V30h5.6c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5"
    />
    <path
      fill="#0597A3"
      d="M25.606 35h63.788A4.6 4.6 0 0 1 94 39.621v34.758C94 76.89 91.997 79 89.394 79H25.606A4.6 4.6 0 0 1 21 74.379V39.621C21.1 37.11 23.103 35 25.606 35"
    />
    <path
      fill="#00D8D8"
      d="M46.57 35 21 50.37v13.16L46.57 79h21.86L94 63.53V50.37L68.43 35z"
    />
    <path
      fill="#0597A3"
      d="M58 72c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14"
    />
    <path
      fill="#001A43"
      d="M63.5 61.408c0-2.83-1.767-4.653-4.5-4.653h-2c-1.5 0-1.5-.76-1.5-1.163s0-1.163 1.5-1.163h4.333c.827 0 1.5-.784 1.5-1.745s-.673-1.745-1.5-1.745H59.5v-.194c0-.962-.673-1.745-1.5-1.745s-1.5.783-1.5 1.745v.217c-2.447.21-4 1.985-4 4.63 0 2.83 1.767 4.653 4.5 4.653h2c1.5 0 1.5.76 1.5 1.163s0 1.163-1.5 1.163h-4.333c-.827 0-1.5.784-1.5 1.745s.673 1.745 1.5 1.745H56.5v.194c0 .962.673 1.745 1.5 1.745s1.5-.783 1.5-1.745v-.217c2.447-.21 4-1.985 4-4.63"
    />
  </svg>
);
const SvgEnrichedIconPayrollInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPayrollInverted);
export default Memo;
